// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"348eab8d","55":"b46e5960","176":"79f5121c","181":"9bb64ac8","384":"5550be63","453":"e31f1d4d","658":"79fdd16c","694":"cabc23a3","729":"cf3f90f4"}[chunkId] + ".chunk.js";
};